import { Card, Header } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import { mapAgreementPrices } from "astrid-firestore/src/api/agreements/utils/agreementMappers";

import Table from "../../../../ui/components/Table/Table";

import useAgreementPricesColumns from "../../../hooks/useAgreementPricesColumns";

export default function TemplatePrices({ template }) {
	const { t } = useTranslation();

	const pricesColumns = useAgreementPricesColumns();

	return (
		<>
			<Header as="h3">{t("prices", "Prices")}</Header>

			<Card fluid>
				<Card.Content>
					<Table data={mapAgreementPrices(template)} columns={pricesColumns} footer={false} />
				</Card.Content>
			</Card>
		</>
	);
}
